var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { CanvasProvider } from './workspace/canvas';
import { ActiveToolProvider } from './workspace/active-tool';
import { DatasetProvider } from './dataset';
import { DatasetNavBarProvider, DatasetNavLocation } from './dataset_navbar';
import { AssetProvider } from './asset';
import { ModalProvider } from './popup/modal';
import { BehaviorSubject } from 'rxjs';
import { AppNavProvider } from '../providers/app_nav';
import { UserProvider } from '../providers/user';
import { TranslateService } from '@ngx-translate/core';
var LockStatus = /** @class */ (function () {
    function LockStatus() {
    }
    return LockStatus;
}());
export { LockStatus };
var AssetLockProvider = /** @class */ (function () {
    function AssetLockProvider(datasetProvider, assetProvider, modalProvider, canvasProvider, activeToolProvider, appNavProvider, userProvider, datasetNavBarProvider, translate) {
        this.datasetProvider = datasetProvider;
        this.assetProvider = assetProvider;
        this.modalProvider = modalProvider;
        this.canvasProvider = canvasProvider;
        this.activeToolProvider = activeToolProvider;
        this.appNavProvider = appNavProvider;
        this.userProvider = userProvider;
        this.datasetNavBarProvider = datasetNavBarProvider;
        this.translate = translate;
        this.isLockedObservable = new BehaviorSubject({
            locked: false,
            lockedBy: ''
        });
        // We need to .bind() scope in order to have access to our scope when running timeout logic.
        // However, doing so changes the function signature, which can prevent removing event listeners.
        // To get around this, we need to store a non-anonymous reference to our function.
        this.updateIdleTimeoutBound = this.updateIdleTimeout.bind(this);
        this.LOCK_RENEWAL_INTERVAL = 55000; // 55 seconds
        this.EXPIRATION_WARNING_INTERVAL = 600000; // 10 minutes (600 seconds)
        // These listeners allow us to estimate when the user is "working".
        window.addEventListener('click', this.updateIdleTimeoutBound, true);
        window.addEventListener('keydown', this.updateIdleTimeoutBound, true);
        window.addEventListener('mousewheel', this.updateIdleTimeoutBound, true);
    }
    Object.defineProperty(AssetLockProvider.prototype, "lockStatus", {
        get: function () {
            return this._lockStatus;
        },
        set: function (status) {
            this._lockStatus = status;
            this.isLockedObservable.next(status);
        },
        enumerable: true,
        configurable: true
    });
    AssetLockProvider.prototype.isAssetLocked = function () {
        return this.lockStatus && this.lockStatus.locked;
    };
    AssetLockProvider.prototype.isAssetLockedByDifferentUser = function () {
        var currentUser = this.userProvider.getUserInformation();
        return this.isAssetLocked() && this.lockStatus.lockedBy !== currentUser.name;
    };
    AssetLockProvider.prototype.lockAsset = function (asset) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, currentUser, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.lockStatus = {
                            locked: false,
                            lockedBy: ''
                        };
                        this.datasetIdentifier = this.datasetProvider.getCurrentDatasetIdentifier();
                        this.asset = asset;
                        if (!this.asset) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.assetProvider.lockAsset(this.asset.id)];
                    case 2:
                        resp = _a.sent();
                        if (resp.acquired) {
                            currentUser = this.userProvider.getUserInformation();
                            this.lockStatus = {
                                locked: true,
                                lockedBy: currentUser.name
                            };
                            this.updateLockInterval();
                            this.updateIdleTimeout();
                        }
                        else {
                            if (resp.lockedByUser) {
                                // If lockedByUser from lockAsset is empty, it means we tried to
                                // lock an asset that we've already locked (instead of renewing the lock).
                                this.lockStatus = {
                                    locked: true,
                                    lockedBy: resp.lockedByUser.name
                                };
                                this.canvasProvider.setLockState(true);
                                this.activeToolProvider.lock();
                                this.showLockModal(true);
                            }
                            else {
                                // Otherwise, we have the lock, and should renew it instead.
                                // This can happen if the user exits out of Brain Builder, but
                                // returns to an asset before their lock would otherwise expire.
                                this.renewAssetLock(true);
                            }
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AssetLockProvider.prototype.renewAssetLock = function (initialLock) {
        if (initialLock === void 0) { initialLock = false; }
        return __awaiter(this, void 0, void 0, function () {
            var resp, currentUser, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this.asset) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.assetProvider.renewAssetLock(this.asset.id)];
                    case 1:
                        resp = _a.sent();
                        if (resp.acquired) {
                            this.updateLockInterval();
                            // If we're "acquiring" the lock by returning to the asset and
                            // renewing the existing lock, that's a good opportunity to set
                            // up an idle timeout.
                            if (initialLock) {
                                this.updateIdleTimeout();
                            }
                        }
                        else {
                            if (this.updateLockTimeout) {
                                // Clear the timeout;
                                window.clearTimeout(this.updateLockTimeout);
                            }
                            currentUser = this.userProvider.getUserInformation();
                            if (resp.lockedByUser) {
                                if (resp.lockedByUser.name !== currentUser.name) {
                                    this.lockStatus = {
                                        locked: true,
                                        lockedBy: resp.lockedByUser.name
                                    };
                                    this.canvasProvider.setLockState(true);
                                    this.activeToolProvider.lock();
                                    this.showLockModal(true);
                                }
                                else {
                                    // If renewing somehow fails, but the lock is supposedly held by the current user,
                                    // don't do anything.
                                    return [2 /*return*/];
                                }
                            }
                            else {
                                // If lockedByUser is falsey (null), then the asset isn't locked.
                                // We should attempt to reacquire the lock.
                                this.lockAsset(this.asset);
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        if (this.updateLockTimeout) {
                            window.clearTimeout(this.updateLockTimeout);
                        }
                        throw e_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AssetLockProvider.prototype.unlockCurrentAsset = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.asset) return [3 /*break*/, 2];
                        this.lockStatus = {
                            locked: false,
                            lockedBy: ''
                        };
                        this.canvasProvider.setLockState(false);
                        this.activeToolProvider.unlock();
                        return [4 /*yield*/, this.assetProvider.unlockAsset(this.asset.id)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /** Attempt to update the lock interval every 55 seconds.
     * This is called by successfully either acquiring a new lock or renewing an existing one.
     */
    AssetLockProvider.prototype.updateLockInterval = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // Clean up the original timeout for safety.
                window.clearTimeout(this.updateLockTimeout);
                // NOTE: window.setTimeout() is used to improve typing.
                this.updateLockTimeout = window.setTimeout(function () {
                    _this.renewAssetLock();
                }, this.LOCK_RENEWAL_INTERVAL);
                return [2 /*return*/];
            });
        });
    };
    AssetLockProvider.prototype.updateIdleTimeout = function (event) {
        var _this = this;
        // If either expiration modal is up, we don't want input to reset the timers.
        // In that case, we should only reset the timers if the user presses a button.
        if (this.expirationWarningModal || this.expirationModal) {
            return;
        }
        window.clearTimeout(this.expirationWarningTimeout);
        // We want to make absolutely sure that the user does not see these modals unless they're in the workspace.
        if (!this.currentViewIsWorkspace()) {
            this.cleanup();
            return;
        }
        this.expirationWarningTimeout = window.setTimeout(function () {
            // Only allow one warning modal on the screen at a time
            if (!_this.expirationWarningModal) {
                _this.expirationWarningModal = _this.modalProvider.createModal('AssetLockExpirationWarningModal', {}, { enableBackdropDismiss: false, cssClass: 'modal-asset-lock-expiration-warning' });
                _this.expirationWarningModal.onDidDismiss(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        delete this.expirationWarningModal;
                        if (data && data.isStillWorking) {
                            this.updateIdleTimeout();
                        }
                        else {
                            if (data && data.timeoutExpired) {
                                this.showLockModal(false);
                            }
                            else {
                                this.appNavProvider.getNavController().setRoot('DatasetPage', {
                                    datasetIdentifier: this.datasetIdentifier
                                });
                                this.cleanup();
                            }
                        }
                        return [2 /*return*/];
                    });
                }); });
                _this.expirationWarningModal.present();
            }
        }, this.EXPIRATION_WARNING_INTERVAL);
    };
    AssetLockProvider.prototype.showLockModal = function (assetAlreadyLocked) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (assetAlreadyLocked && this.lockStatus && this.lockStatus.locked) {
                            // The user has lost their lock through inactivity; make sure it doesn't linger.
                            this.unlockCurrentAsset();
                        }
                        this.cleanup();
                        // Like the warning modal, this should never appear outside the workspace.
                        if (!this.currentViewIsWorkspace()) {
                            this.cleanup();
                            return [2 /*return*/];
                        }
                        if (!assetAlreadyLocked) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.modalProvider.presentAlert(this.translate.instant('This asset is currently locked.'), this.translate.instant('<p>This asset is currently being worked on by another user in the organization. You will be unable to interact with this asset until they are done.</p><p>Note: If the user is inactive for more than 10 minutes, the system will prompt them to confirm they are still working. If there is no response after 5 minutes, their session will expire, and the asset will be available for use.</p>'), this.translate.instant('Okay'))];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.modalProvider.presentAlert(this.translate.instant('This session has timed out.'), this.translate.instant('Please refresh the page to continue working.'), this.translate.instant('Okay'))];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.appNavProvider.getNavController().setRoot('DatasetPage', {
                            datasetIdentifier: this.datasetIdentifier
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AssetLockProvider.prototype.cleanup = function () {
        if (this.updateLockTimeout) {
            window.clearTimeout(this.updateLockTimeout);
        }
        if (this.expirationWarningTimeout) {
            window.clearTimeout(this.expirationWarningTimeout);
        }
    };
    AssetLockProvider.prototype.currentViewIsWorkspace = function () {
        return this.datasetNavBarProvider.getActivePage() === DatasetNavLocation.Workspace;
    };
    // See BB-5689: When navigating from Evaluate page in edit mode, we are trying to acquire a lock
    // on an asset that already holds a lock. By checking if it's locked, we can renew lock
    AssetLockProvider.prototype.ensureAssetLock = function (asset) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isAssetLocked()) return [3 /*break*/, 1];
                        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.renewAssetLock(true)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, 100);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.lockAsset(asset)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AssetLockProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [DatasetProvider,
            AssetProvider,
            ModalProvider,
            CanvasProvider,
            ActiveToolProvider,
            AppNavProvider,
            UserProvider,
            DatasetNavBarProvider,
            TranslateService])
    ], AssetLockProvider);
    return AssetLockProvider;
}());
export { AssetLockProvider };
//# sourceMappingURL=asset_lock.js.map


// WEBPACK FOOTER //
// ./src/providers/asset_lock.ts.pre-build-optimizer.js